import { adminPaths } from "@app/routing/adminPaths";
import { KnowledgeBaseItemType } from "@generated/client/graphql";
import { atom } from "jotai";

export const activeTypeAtom = atom<KnowledgeBaseItemType>(
    KnowledgeBaseItemType.CustomItem,
);

export const isAddCustomItemModalOpenAtom = atom<boolean>(false);

export const button_props: Record<
    string,
    {
        button_text: string[];
        to: (orgUname?: string) => string[];
    }
> = {
    CUSTOM_ITEM: {
        button_text: ["add_custom_item"],
        to: () => [""],
    },
    DOCUMENT: {
        button_text: ["edit_policy", "edit_measure", "edit_document"],
        to: (orgUname?: string) => [
            `/o/${orgUname}/admin/${adminPaths.policies}`,
            `/o/${orgUname}/admin/${adminPaths.measures}`,
            `/o/${orgUname}/admin/${adminPaths.custom_documents}`,
        ],
    },
    FRAMEWORK: {
        button_text: ["edit_framework"],
        to: (orgUname?: string) => [
            `/o/${orgUname}/admin/${adminPaths.frameworks}`,
        ],
    },
    QUESTIONNAIRE: {
        button_text: ["edit_questionnaire"],
        to: (orgUname?: string) => [
            `/o/${orgUname}/admin/${adminPaths.external_questionnaires}`,
        ],
    },
    INDICATOR: {
        button_text: ["edit_indicator"],
        to: (orgUname?: string) => [
            `/o/${orgUname}/admin/${adminPaths.reporting}`,
        ],
    },
    OBJECTIVE: {
        button_text: ["edit_objective"],
        to: (orgUname?: string) => [
            `/o/${orgUname}/admin/${adminPaths.objectives}`,
        ],
    },
} as const;
